import React, { Component } from 'react';
import Store from '../../../../redux/Store';
import InstrumentStateTypes from './InstrumentStateTypes';
import Constants from '../../../../common/constants/Constants';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import { getData, updateInstrumentStateType } from './InstrumentStateTypes.actions';
import { connect } from 'react-redux';

class InstrumentStateTypesContainer extends Component {
  constructor() {
    super();

    this.state = {
      alerts: [],
      data: [],
    };

    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    getData().then((res) => {
      const alerts = res[0].slice().sort((a, b) => a.Level - b.Level);
      this.setState({
        alerts,
        data: res[1],
      });
    });
  }

  render() {
    return (
      <InstrumentStateTypes
        data={this.state.data}
        alerts={this.state.alerts}
        onChange={this._onChange}
      />
    );
  }

  _onChange(id, event) {
    const elementToEditIndex = this.state.data.findIndex(
      (el) => el.InstrumentStateTypeEntityId === id
    );
    const alert = this.state.alerts.find((alert) => alert.Level === event) || {};

    const elem = Object.assign({}, this.state.data[elementToEditIndex]);
    elem.AlertSeverityTypeEntity = Object.assign({}, alert);
    elem.AlertSeverityTypeEntityId = alert.AlertSeverityTypeEntityId;

    const data = this.state.data.slice(0);
    data[elementToEditIndex] = elem;

    this.setState({ data });

    updateInstrumentStateType(elem.InstrumentStateTypeEntityId, elem)
      .then((res) =>
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'Successfully updated alert severity.',
          })
        )
      )
      .catch((res) => console.log(res));
  }
}

const mapStateToProps = (state, props) => ({
  notifications: state.notifications.notifications || [],
});

export default connect(mapStateToProps, {})(InstrumentStateTypesContainer);
